import * as React from 'react';
import moment from 'moment';
import cn from 'classnames';
import { DATE_FORMAT } from './constants';
function Day(props) {
    var date = props.date, selected = props.selected, minDate = props.minDate, maxDate = props.maxDate, onDayClick = props.onDayClick;
    var momentCurrentDate = moment(date, DATE_FORMAT).clone();
    var momentMinDate = minDate && moment(minDate, DATE_FORMAT);
    var momentMaxDate = maxDate && moment(maxDate, DATE_FORMAT);
    var momentSelected = selected ? moment(selected, DATE_FORMAT) : null;
    var lessThanMinDate = minDate
        ? momentCurrentDate.isBefore(momentMinDate)
        : false;
    var moreThanMaxDate = maxDate
        ? momentCurrentDate.isAfter(momentMaxDate)
        : false;
    var isDisabled = lessThanMinDate || moreThanMaxDate;
    var className = cn({
        Calendar__day: true,
        Calendar__day_weekend: momentCurrentDate.day() === 0,
        Calendar__day_today: momentCurrentDate.isSame(moment().startOf('day')),
        Calendar__day_selected: momentSelected &&
            momentCurrentDate.isSame(momentSelected.clone().startOf('day')),
        Calendar__day_disabled: isDisabled
    });
    return (React.createElement("td", { className: className, key: momentCurrentDate.valueOf() }, isDisabled ? (React.createElement("span", { className: "Calendar__dayButton" }, momentCurrentDate.format('D'))) : (React.createElement("button", { type: "button", onMouseDown: function () { return onDayClick(date); }, className: "Calendar__dayButton" }, momentCurrentDate.format('D')))));
}
export default Day;
//# sourceMappingURL=Day.js.map